/**
 * Billing Storage Helper
 * Manages localStorage for billing information with merge capabilities
 */
class BillingStorage {
  static key = 'milan_billing_info';

  static load() {
    try {
      const data = JSON.parse(localStorage.getItem(this.key)) || {};
      return data;
    } catch (error) {
      console.warn('Error loading billing data from localStorage:', error);
      return {};
    }
  }

  // Merge and save data
  static save(patchObj) {
    try {
      const data = { ...this.load(), ...patchObj };
      localStorage.setItem(this.key, JSON.stringify(data));
    } catch (error) {
      console.warn('Error saving billing data to localStorage:', error);
      // Silent fail - localStorage might be unavailable
    }
  }

  static clear() {
    try {
      localStorage.removeItem(this.key);
    } catch (error) {
      console.warn('Error clearing billing data from localStorage:', error);
    }
  }
}

// Export for ES6 modules or make globally available
if (typeof module !== 'undefined' && module.exports) {
  module.exports = BillingStorage;
} else {
  window.BillingStorage = BillingStorage;
}
